import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/comment-templates'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

/** Active templates and add-on lines for the picker next to a comment box (COMMENT_FIELD). */
function GetActive(commentField: string) {
  return ApiRequest.get(`${BaseRoute}/active`, { params: { commentField } })
}

/** ids: every template, in the new display order. */
function Reorder(ids: string[]) {
  return ApiRequest.put(`${BaseRoute}/reorder`, { ids })
}

const CommentTemplate = {
  ...baseFunctions,
  GetActive,
  Reorder,
}

export default CommentTemplate
